import React from "react";
import LocaleStrings from "Languages";

export var NO_TICKET = "tickets";
export var NO_REVIEWER = "reviewer";
export var NO_COURSE = "course";

var NoContent = ({ contentType }) => {
  var iconURL = `../../style/images/no-content-icons/no-${contentType}.png`;
  var message = "";
  var submessage = "";

  switch (contentType) {
    case NO_TICKET:
      message = LocaleStrings.user_resistration_menus_no_ticket_content_title;
      submessage =
        LocaleStrings.user_resistration_menus_no_ticket_content_subtitle;
      break;
    case NO_REVIEWER:
      message = LocaleStrings.proposal_wizard_no_reviewer_content_title;
      submessage = LocaleStrings.proposal_wizard_no_reviewer_content_subtitle;
      break;
    case NO_COURSE:
      message = LocaleStrings.course_no_course_content_title;
      submessage = LocaleStrings.course_no_course_content_subtitle;
      break;
    default:
  }

  return (
    <div className="no-content-container">
      <div>
        <div className="custom-align-center">
          <img src={iconURL} alt="no-content-icon" />
        </div>
        <div className="no-content-message">{message}</div>
        <div className="no-content-message">{submessage}</div>
      </div>
    </div>
  );
};

export default NoContent;
